import { render, staticRenderFns } from "./MovementDetail.vue?vue&type=template&id=3f052e1c"
import script from "./MovementDetail.vue?vue&type=script&lang=js"
export * from "./MovementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports